module.exports = __webpack_public_path__ + "static/media/icn-access.98f5be82.svg";